export const cats = [
 "Abyssinian",
   "American Bobtail",
   "American Curl",
   "American Shorthair",
   "American Wirehair",
   "Anatolian",
   "Ashera",
   "Angora",
   "Balinese",
   "Bengal",
   "Birman",
   "Bombay",
   "British Longhair",
   "British Shorthair",
   "Bullseye",
   "Burmese",
   "California Spangled",
  "Canadian Hairless (Sphynx)",
   "Chantilly-Tiffany",
   "Chartreux",
   "Chausie",
   "Chinchilla Persian",
   "Cheeto",
   "Chinchilla",
   "Cornish Rex",
   "Cymric",
   "Devon Rex",
   "Donskoy",
   "Domestic Mediumhair",
   "Egyptian Mau",
   "European Burmese",
   "Exotic Longhair",
   "Exotic Shorthair",
   "Habari",
   "Highlander",
   "Havana Brown",
   "Himalayan",
   "Japanese Bobtail",
   "Javanese",
   "Kashmir",
   "Kurilian Bobtail",
   "Korat",
   "LaPerm",
   "Lykoi",
   "Maine Coon",
   "Manx",
   "Manx Longhair",
   "Minuet",
   "Mixed Breed",
   "Munchkin",
   "Napoleon",
   "Nebelung",
   "Norwegian Forest",
   "Ocicat",
   "Ojos Azules",
   "Oriental",
  "Other Cat",
   "Other Hyrbridcat",
   "Persian",
   "Persian-Himalayan",
   "Peterbald",
   "Pixiebob",
   "Ragamuffin",
   "Ragdoll",
   "Rex",
   "Russian Blue",
   "Safari",
    "Savannah",
   "Schnoodle",
   "Snowshoe",
   "Scottish Deerhound",
    "Scottish Fold",
   "Scottish Terrier",
   "Scottish Terrier/Aberdeen",
   "Sealyham Terrier",
   "Segugio Italiano",
    "Selkirk Rex",
    "Serengeti",
   "Shar Pei",
   "Shorthair Chinchilla",
    "Siamese",
    "Siberian",
    "Singapura",
   "Snowshoe",
    "Somali",
    "Sphynx",
   "Tabby",
   "Thai",
    "Tiffany",
    "Tonkinese",
    "Toyger",
    "Turkish Angora",
    "Turkish Van",
    "York Chocolate",
    "American Long Hair",
    "American Wirehair",
    "Colorpoint Shorthair",
    "Domestic Longhair",
    "Domestic Mediumhair",
    "Domestic Shorthair",
]
